const LINE_URL = 'https://lin.ee/PNbhQI0';

export default function LineFloatingButton() {
  return (
    <a
      href={LINE_URL}
      target="_blank"
      rel="nofollow noopener noreferrer"
      aria-label="LINEで相談する"
      className="fixed bottom-6 right-6 z-50 animate-bounceY flex items-center justify-center w-[50px] h-[50px] rounded-full shadow-lg hover:opacity-90 transition-opacity"
      style={{ background: '#06C755' }}
    >
      <span className="flex items-center justify-center w-7 h-7">
        <i className="ri-line-fill text-white text-2xl"></i>
      </span>
    </a>
  );
}
